import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Callout } from 'seagull';
import { billingCreditsTextsPath, getCreditsWarning } from '~/business-logic/billingLogic';
import { useLocaleKeys } from '~/i18n';
import { serviceModel } from '~/models';
import { getIssueDateBeforeRelationshipEffectiveDateWarning } from '../../utils/BillClientModal.utils';
import { getClientApprovalCalloutText } from '../BillChargeTableItem/BillChargeTableItem.utils';
import { billClientModalTextsPath, getBillServiceBeforeItsEffectiveDateWarning } from '../BillServiceTableItem/BillServiceTableItem.utils';
import { getVariantClass, getVariantSkin } from './Callouts.utils';
export function BillChargeClientApprovalCallout(param) {
    let { issueDate, invoiceDateInfo, testId, variant } = param;
    const { t: billTexts } = useLocaleKeys(billClientModalTextsPath);
    const text = useMemo(()=>getClientApprovalCalloutText({
            issueDate,
            invoiceDateInfo,
            calloutTexts: billTexts.clientApprovalCallout
        }), [
        issueDate,
        invoiceDateInfo
    ]);
    return /*#__PURE__*/ _jsx(Callout, {
        classes: {
            wrapper: getVariantClass(variant)
        },
        skin: getVariantSkin(variant),
        testId: testId,
        withBorder: true,
        children: text
    });
}
export function ServiceEffectiveDateCallout(param) {
    let { mode, service, issueDate, relationshipEffectiveDate, testId, variant } = param;
    const warning = useMemo(()=>getBillServiceBeforeItsEffectiveDateWarning(mode, service, issueDate, relationshipEffectiveDate), [
        mode,
        service,
        issueDate,
        relationshipEffectiveDate
    ]);
    if (!warning) return null;
    return /*#__PURE__*/ _jsx(Callout, {
        classes: {
            wrapper: getVariantClass(variant)
        },
        skin: getVariantSkin(variant),
        testId: testId,
        withBorder: true,
        children: warning.text
    });
}
export function ServicePendingAmendmentCallout(param) {
    let { service, testId, variant } = param;
    const { t: billTexts } = useLocaleKeys(billClientModalTextsPath);
    const isPendingOrAmended = serviceModel.isAwaitingApproval(service.status) || serviceModel.isAmended(service.status);
    if (!isPendingOrAmended) return null;
    return /*#__PURE__*/ _jsx(Callout, {
        classes: {
            wrapper: getVariantClass(variant)
        },
        skin: getVariantSkin(variant),
        testId: testId,
        intent: "warning",
        withBorder: true,
        children: billTexts.pendingAmendmentRequiresApproval()
    });
}
export function CreditsWarningCallout(param) {
    let { totalCredits, testId, variant } = param;
    const { t: billingCreditsTexts } = useLocaleKeys(billingCreditsTextsPath);
    const warning = useMemo(()=>getCreditsWarning(totalCredits, billingCreditsTexts), [
        totalCredits
    ]);
    if (!warning) return null;
    return /*#__PURE__*/ _jsx(Callout, {
        classes: {
            wrapper: getVariantClass(variant)
        },
        skin: getVariantSkin(variant),
        testId: testId,
        withBorder: true,
        children: warning.text
    });
}
export function RelationshipEffectiveDateCallout(param) {
    let { issueDate, effectiveDate, testId, variant } = param;
    const warning = useMemo(()=>getIssueDateBeforeRelationshipEffectiveDateWarning(effectiveDate, issueDate), [
        issueDate,
        effectiveDate
    ]);
    if (!warning) return null;
    return /*#__PURE__*/ _jsx(Callout, {
        classes: {
            wrapper: getVariantClass(variant)
        },
        skin: getVariantSkin(variant),
        testId: testId,
        withBorder: true,
        children: warning.text
    });
}
